'use strict';

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var formPrepare = require('./../../../../app_storefront_core/cartridge/js/pages/checkout/formPrepare');
var dialog = require('./../dialog');
var layout = require('./../layout');
var progress = require('./../progress');

var $cache = {};

function initializeCache() {
    $cache.document = $(document);
    $cache.contactUsModal = $('.contact-us-modal');

};

function handleFileInput() {
    $( '#uploadFile' ).on("change", function(e){ 
        if ($('#fileError').length) {
            $('#fileError').empty();
            $('#fileError').remove();
        }
        var error = $('<div id="fileError" class="error"></div>');
        var inputContainer = $( '#uploadFile' ).closest('.f-field-wrapper')
        const [ file ] = e.target.files
  
        if (!file) return
      
        const { size, type } = file
      
        if (size > 6291456) {
          $('.js-upload-file').attr('disabled', 'disabled');
          error.text(Resources.VALIDATE_FILE_BIG);
          inputContainer.append(error);
          throw "too big"
        } else if (
          type !== "application/pdf" &&
          type !== "image/jpeg" && type !== "image/jpg" && type !== "image/bmp" && type !== "image/png"
        ) {
            $('.js-upload-file').attr('disabled', 'disabled');  
            error.text(Resources.VALIDATE_FILE_WRONG);
            inputContainer.append(error);
            throw "not the right type"
        } else {
            $('.js-upload-file').removeAttr('disabled');
            if ($('#fileError').length) {
                $('#fileError').empty();
                $('#fileError').remove();
            }    
        }
     });
}

function initializeEvents() {
    $cache.document.on('change', '#dwfrm_contactusemail_isPurchaseRelated', function(event){
        event.preventDefault();
        toggleFields();
    });


    $cache.document.on('click', '.js-upload-file', function(event) {
        event.preventDefault();
        progress.show($cache.contactUsModal);
        var url = $('#attachmentUpload').attr('data-action');

        var data = new FormData();
        var tokenName = $('.js-csrftoken').find('input').attr('name');
        data.append( 'file', $( '#uploadFile' )[0].files[0] );
        data.append( tokenName, $('.js-csrftoken').find('input').val() );

        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'json',
            cache: false,
            processData: false,
            contentType: false,
            success: function(data) {
                $('.f-field--attachmentURL').find('input').val(data.filePath);
                $('.js-upload-file').val(data.filePath);
                $('.js-upload-file').attr('disabled', 'disabled');
                formPrepare.validateForm();
                progress.hide();
            }
        })
    });

    $cache.document.on('submit', '#contactUsEmailForm', function(event) {
        event.preventDefault();

        progress.show($cache.contactUsModal);

        var $form = $(this);
        var dataArr = $form.serialize().split('&');
        var fakeDataArr = [];
        var requiredFields = $form.find('.required:input');
        requiredFields.each(function() {
            //set fake data for empty required data for form at xml level
            if (!this.value) {
                fakeDataArr.push(this.name + '=' + 'xxxxxxxxxx')
            }
        });

        var newDataArr = dataArr.filter(function(item) {
            return !item || item.indexOf('=') + 1 !== item.length;
        });

        var submitName = $form.find('.js-submit-container').find('button').attr('name');
        var data = [newDataArr.join('&'), fakeDataArr.join('&'), submitName + '=true'].join('&');

        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: data,
            success: function(data) {
                dialog.openWithContent({
                    html: data
                });

                progress.hide();
            }
        })
    });
};

function toggleRelatedPurchaseFields() {
    $('.f-field--typeOfPurchase').toggleClass('hidden');
    $('.f-field--orderNumber').toggleClass('hidden');
    $('.f-field--billingPostCode').toggleClass('hidden');
    $('.f-field--attachment').toggleClass('hidden');

    var $whereIsMyOrder = $('[value="whereIsMyOrder"]');
    var $itemFaulty = $('[value="itemFaulty"]');
    var $cancelOrder = $('[value="cancelOrder"]');
    var $discussReturn = $('[value="discussReturn"]');
    var $missingItem = $('[value="missingItem"]');
    var $helpOption = $('[value="helpOption"]');

    $whereIsMyOrder.toggleClass('hidden');
    $itemFaulty.toggleClass('hidden');
    $cancelOrder.toggleClass('hidden');
    $discussReturn.toggleClass('hidden');
    $missingItem.toggleClass('hidden');
    $helpOption.toggleClass('hidden');

    if (!layout.isMobile()) {
        return;
    }

    // ios mobile fix
    if ($whereIsMyOrder.hasClass('hidden')) {
        $whereIsMyOrder.wrap('<span>');
        $itemFaulty.wrap('<span>');
        $cancelOrder.wrap('<span>');
        $discussReturn.wrap('<span>');
        $missingItem.wrap('<span>');
        $helpOption.wrap('<span>');
    } else {
        $whereIsMyOrder.unwrap();
        $itemFaulty.unwrap();
        $cancelOrder.unwrap();
        $discussReturn.unwrap();
        $missingItem.unwrap();
        $helpOption.unwrap();
    }

}

function toggleNoRelatedPurchaseFields(){
    var $generalQuery = $('[value="generalQuery"]');
    var $thinkingPurchasing = $('[value="thinkingPurchasing"]')

    $generalQuery.toggleClass('hidden');
    $thinkingPurchasing.toggleClass('hidden');

    if (!layout.isMobile()) {
        return;
    }

        // ios mobile fix
    if ($generalQuery.hasClass('hidden')) {
        $generalQuery.wrap('<span>');
        $thinkingPurchasing.wrap('<span>');
    } else {
        $generalQuery.unwrap();
        $thinkingPurchasing.unwrap();
    }
}

function toggleFields() {
    var $questionSelect = $('#dwfrm_contactusemail_questionOptions');
    $questionSelect.val('');

    toggleRelatedPurchaseFields();
    toggleNoRelatedPurchaseFields();

    formPrepare.init({
        continueSelector: '[name$="dwfrm_contactusemail_send"]',
        formSelector: 'form[id$="contactUsEmailForm"]'
    });
}

module.exports = {
    init: function() {
        initializeCache();
        initializeEvents();
    },
    initOpen: function() {
        var $isPurchaseRelated = $('#dwfrm_contactusemail_isPurchaseRelated');
        $('[value="pleaseSelectPurchaseRelated"]').attr('disabled', 'disabled');

        if ($isPurchaseRelated.val() === "true") {
            toggleNoRelatedPurchaseFields();
        } else {
            toggleRelatedPurchaseFields()
        }

        handleFileInput();

        var maxHeigth = $(window).height() - 100;
        $('.contact-us-modal .blockWithScroll').css('max-height', maxHeigth);
        $('.f-field-required_indicator').css('color', 'red');

        formPrepare.init({
            continueSelector: '[name$="dwfrm_contactusemail_send"]',
            formSelector: 'form[id$="contactUsEmailForm"]'
        });
    }
}
